<template>
    <div class="container" style="max-width: 85%;">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <card-component titulo="Lista dos Lançamentos" componente="caixinha" :usuario="userJson">
                    <template v-slot:conteudo>
                        <div class="row">
                            <div class="col-1 mb-3">
                                <input-container-component titulo="ID" id="inputid">
                                    <input type="text" class="form-control" id="inputid" placeholder="Informe o id"
                                        v-model="busca.id" @keyup="pesquisar()">
                                </input-container-component>
                            </div>
                            <div class="col-2 mb-3">
                                <input-container-component titulo="Descricao" id="inputDescricao">
                                    <input type="text" class="form-control" id="inputDescricao"
                                        placeholder="Informe a Descricao" v-model="busca.descricao"
                                        @keyup="pesquisar()">
                                </input-container-component>
                            </div>
                            <div class="col-2 mb-3">
                                <input-container-component titulo="Fornecedor" id="inputFornecedor">
                                    <input type="text" class="form-control" id="inputFornecedor"
                                        placeholder="Informe o Fornecedor" v-model="busca.fornecedor"
                                        @keyup="pesquisar()">
                                </input-container-component>
                            </div>
                            <div class="col-2 mb-3" v-if="userJson.nivel_acesso == 'adm'">
                                <input-container-component titulo="Caps">
                                    <select name="caps_lan" class="form-control" id="caps_lan" @change="filtroCaps">
                                        <option selected></option>
                                        <option value="1">Sede</option>
                                        <option value="2">Novo Tempo</option>
                                        <option value="5">David Capstrano</option>
                                        <option value="6">Estação</option>
                                        <option value="7">Integração</option>
                                        <option value="9">Toninho</option>
                                        <option value="10">Esperanca</option>
                                    </select>
                                </input-container-component>
                            </div>
                            <div class="col-3 mb-3">
                                <input-container-component titulo="Filtrar Status">
                                    <select name="filtroStatus" class="form-control" id="filtroStatus"
                                        v-model="busca.status" @change="pesquisar()">
                                        <option selected></option>
                                        <option value="criacao" selected>Criação
                                        </option>
                                        <option v-if="userJson.nivel_acesso == 'adm'" value="pendente">Pend. Pagamento
                                        </option>
                                        <option value="pago">Pend. Comprovante</option>
                                        <option value="finalizado">Proc. Finalizado</option>
                                        <option v-if="userJson.nivel_acesso == 'adm'" value="taxa">Taxa Transação
                                        </option>
                                    </select>
                                </input-container-component>
                            </div>
                            <div class="col">
                                <button type="button" class="btn btn-primary btn-sm float-end"
                                    @click="carregarBotaoAdicionar()">
                                    Adicionar
                                </button>
                            </div>
                            <div class="col" v-if="userJson.nivel_acesso == 'adm'">
                                <button type="button" class="btn btn-primary btn-sm float-end" data-bs-toggle="modal"
                                    data-bs-target="#modalExportarTxt">
                                    Exportar TXT
                                </button>
                            </div>
                            <div class="col" v-if="userJson.nivel_acesso == 'adm'">
                                <button type="button" class="btn btn-success btn-sm float-end" data-bs-toggle="modal"
                                    data-bs-target="#modalExportarXLS">
                                    Exportar XLS
                                </button>
                            </div>
                        </div>
                        <table-component :dados="lancamentos.data" componentpai="landesc" :status="true" :pdf="{
                            url: 'cx'
                        }" :editar="{
                            visivel: true,
                            dataToggle: 'modal',
                            dataTarget: '#modalLancamentoAtualizar'
                        }" :remover="{
                            visivel: true,
                            dataToggle: 'modal',
                            dataTarget: '#modalLancamentoRemover'
                        }" :titulos="{
                            id: { titulo: 'ID', tipo: 'texto' },
                            aprovacao: { titulo: 'Aprovação', tipo: '' },
                            status: { titulo: 'Status', tipo: 'status' },
                            descricao: { titulo: 'Descrição', tipo: 'texto' },
                            valor_comprovante: { titulo: 'Valor Comprovante', tipo: 'texto' },
                            fornecedor: { titulo: 'Fornecedor', tipo: 'texto' },
                            caps: { titulo: 'Caps Lancamento', tipo: '' },
                            data_lancamento: { titulo: 'Data', tipo: 'dataCx' },
                            tipo_operacao: { titulo: 'Operação', tipo: 'texto' },
                            nome_paciente: { titulo: 'Rateio', tipo: 'texto' },
                        }"></table-component>
                    </template>
                    <template v-slot:rodape>
                        <div class="row">
                            <div class="col-12">
                                <paginate-component>
                                    <li v-for="l, key in lancamentos.links" :key="key"
                                        :class="l.active ? 'page-item active' : 'page-item'"><a class="page-link"
                                            v-html="l.label" @click="paginacao(l)"></a></li>
                                </paginate-component>
                            </div>
                        </div>
                    </template>
                </card-component>
            </div>
        </div>

        <modal-component id="modalLanDescricao" titulo="Adicionar Lancamento">
            <template v-slot:alertas>
                <alert-component tipo="success" :detalhes="transacaoDetalhes" titulo="Cadastro realizado com sucesso!"
                    v-if="transacaoStatus == 'sucesso'"></alert-component>
                <alert-component tipo="danger" :detalhes="transacaoDetalhes" titulo="Erro ao cadastrar."
                    v-if="transacaoStatus == 'erro'"></alert-component>
            </template>
            <template v-slot:conteudo>
                <div class="form-group">
                    <input-container-component titulo="Data Lancamento" id="data_lancamento">
                        <input type="date" class="form-control" id="data_lancamento" v-model="data_lancamento"
                            @keydown.prevent :min="dataMin" @focus="bloquearTeclado">
                    </input-container-component>
                </div>
                <div class="form-group">
                    <input-container-component titulo="Descrição" id="novoLancamento">
                        <select name="descricao" class="form-control" id="novoLancamento" v-model="lanDescricao">
                            <option v-for="lista in listaDescricao" :key="lista.id" :value="lista.descricao">
                                {{ lista.descricao }}
                            </option>
                        </select>
                    </input-container-component>
                </div>
                <div class="form-group mt-3">
                    <input-container-component titulo="Valor" id="novoValorComprovante">
                        <input type="text" class="form-control" id="novoValorComprovante" placeholder="Informe o Valor"
                            v-model="lanValorComprovante" @input="aplicarMascaraLanDesc($event, 'adicionar')">
                    </input-container-component>
                </div>
                <div class="form-group mt-3">
                    <input-container-component titulo="Fornecedor" id="novoFornecedor">
                        <input type="text" class="form-control" id="novoFornecedor" placeholder="Informe o Fornecedor"
                            v-model="lanFornecedor" @input="fetchResultsForn('adicionar')">
                    </input-container-component>
                    <ul v-if="searchResultsForn.length > 0" class="list-group">
                        <li v-for="item in searchResultsForn" :key="item.id"
                            class="list-group-item list-group-item-action" @click="setFornecedor(item, 'adicionar')">
                            {{ item.razao_social }}
                        </li>
                    </ul>
                </div>
                <div class="form-group mt-3">
                    <input-container-component titulo="Tipo Operacao">
                        <select name="novoTipoOperacao" class="form-control" id="novoTipoOperacao"
                            v-model="tipo_operacao">
                            <option selected></option>
                            <option value="entrada">Entrada</option>
                            <option value="saida">Saida</option>
                        </select>
                    </input-container-component>
                </div>
            </template>
            <template v-slot:rodape>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                <button type="button" class="btn btn-primary" @click="salvarLanDescricao()">Salvar</button>
            </template>
        </modal-component>

        <modal-component id="modalLancamentoAtualizar" titulo="Atualizar Lançamento" tipomodal="modal-xl">
            <template v-slot:alertas>
                <alert-component tipo="success" :detalhes="$store.state.transacao.mensagem"
                    titulo="Lançamento atualizado com sucesso!"
                    v-if="$store.state.transacao.status == 'sucesso'"></alert-component>
                <alert-component tipo="danger" :detalhes="$store.state.transacao.mensagem" titulo="Erro ao atualizar."
                    v-if="$store.state.transacao.status == 'erro'"></alert-component>
            </template>
            <template v-slot:conteudo>
                <div class="row" style="justify-content: center;">
                    <div class="col-6">
                        <button type="button" class="btn btn-primary btn-sm mb-3 float-end" @click="aprovacao()"
                            v-if="userJson.nivel_acesso == 'gestor' && $store.state.item.status == 'finalizado' && $store.state.item.aprovacao != 'sim'">
                            Aprovação Gestor
                        </button>
                        <button type="button" class="btn btn-primary btn-sm mb-3 float-end" @click="reprovar()"
                            v-if="userJson.nivel_acesso == 'adm' && $store.state.item.aprovacao == 'sim'">
                            Desfazer Aprovação
                        </button>
                        <div v-if="$store.state.item.status == 'finalizado' && $store.state.item.aprovacao != 'sim'">
                            <button type="button" class="btn btn-primary btn-sm float-end" @click="habilitarEdicao()">
                                Editar Lançamento
                            </button>
                        </div>
                        <div class="row">
                            <div class="col" v-if="$store.state.item.status == 'criacao'">
                                <label class="custom-file-upload float-start">
                                    <input type="file" style="display: none" @change="carregarImagem($event)"
                                        id="inputImagem" name="imagem" />
                                    <a class="btn btn-outline-primary btn-sm d-inline"> Nota Fiscal </a>
                                </label>
                                <p v-if="nomeArquivo" class="text-success mt-2 mb-2 float-start">
                                    Arquivo carregado: {{ nomeArquivo }}
                                </p>
                            </div>
                        </div>
                        <div class="row mt-2 mb-3" v-if="$store.state.item.imagem">
                            <a :href="'/storage/' + $store.state.item.imagem" target="_blank">Nota Fiscal</a>
                        </div>

                        <div class="row mt-2 mb-3">
                            <b>ID: {{ $store.state.item.id }}</b>
                        </div>
                        <div>
                            <div class="form-group">
                                <input-container-component titulo="Data Lancamento" id="data_lancamento">
                                    <input type="date" class="form-control" id="data_lancamento"
                                        v-model="$store.state.item.data_lancamento" @keydown.prevent :min="dataMin"
                                        @focus="bloquearTeclado" :disabled="$store.state.item.status != 'criacao'">
                                </input-container-component>
                            </div>
                            <div class="form-group">
                                <input-container-component titulo="Descrição" id="atualizarLancamento">
                                    <select name="descricao" class="form-control" id="atualizarLancamento"
                                        v-model="$store.state.item.descricao"
                                        :disabled="$store.state.item.status != 'criacao'">
                                        <option v-for="lista in listaDescricao" :key="lista.id"
                                            :value="lista.descricao">
                                            {{ lista.descricao }}
                                        </option>
                                    </select>
                                </input-container-component>
                            </div>
                        </div>
                        <div>
                            <div class="form-group mt-3">
                                <input-container-component titulo="Valor Comprovante" id="atualizarValorComprovante">
                                    <input type="text" class="form-control" id="atualizarValorComprovante"
                                        placeholder="Informe o Valor Comprovante"
                                        v-model="$store.state.item.valor_comprovante"
                                        @input="aplicarMascaraLanDesc($event, 'atualizar')"
                                        :disabled="$store.state.item.status != 'criacao'">
                                </input-container-component>
                            </div>
                            <div class="form-group mt-3">
                                <input-container-component titulo="Fornecedor" id="atualizarFornecedor">
                                    <input type="text" class="form-control" id="atualizarFornecedor"
                                        placeholder="Informe o Fornecedor" v-model="$store.state.item.fornecedor"
                                        @input="fetchResultsForn('atualizar')"
                                        :disabled="$store.state.item.status != 'criacao'">
                                </input-container-component>
                                <ul v-if="searchResultsForn.length > 0" class="list-group">
                                    <li v-for="item in searchResultsForn" :key="item.id"
                                        class="list-group-item list-group-item-action"
                                        @click="setFornecedor(item, 'atualizar')">
                                        {{ item.razao_social }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div>
                            <div class="form-group mt-3">
                                <input-container-component titulo="Tipo Operacao">
                                    <select name="novoTipoOperacao" class="form-control" id="novoTipoOperacao"
                                        v-model="$store.state.item.tipo_operacao"
                                        :disabled="$store.state.item.status != 'criacao'">
                                        <option selected></option>
                                        <option value="entrada">Entrada</option>
                                        <option value="saida">Saida</option>
                                    </select>
                                </input-container-component>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <lanrateio-caixa-component v-if="exibirRateio" ref="lanRateio" :nivelacesso="userJson.nivel_acesso"
                    :capsid="userJson.caps_id" @atualizar-saldo="fetchResultsStoreCx"
                    :rateiosalvar="salvarRateio"></lanrateio-caixa-component>
            </template>
            <template v-slot:rodape>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                <button type="button" class="btn btn-primary" @click="atualizarLanDescricao()"
                    v-if="$store.state.item.status == 'criacao'">Atualizar</button>
            </template>
        </modal-component>
        <!-- ####################################################### -->
        <!-- ############## Moral Remover ################### -->
        <!-- ####################################################### -->
        <modal-component id="modalLancamentoRemover" titulo="Remover Lançamento" tipomodal="modal-xl"
            @modal-aberto="onModalAberto" insert>
            <template v-slot:alertas>
                <alert-component tipo="success" :detalhes="$store.state.transacao.mensagem"
                    titulo="Lançamento atualizado com sucesso!"
                    v-if="$store.state.transacao.status == 'sucesso'"></alert-component>
                <alert-component tipo="danger" :detalhes="$store.state.transacao.mensagem" titulo="Erro ao atualizar."
                    v-if="$store.state.transacao.status == 'erro'"></alert-component>
            </template>
            <template v-slot:conteudo>
                <div class="row mt-2 mb-3">
                    <b>ID: {{ $store.state.item.id }}</b>
                </div>
                <div>
                    <div class="form-group">
                        <input-container-component titulo="Data Lancamento" id="remover_data_lancamento">
                            <input type="date" class="form-control" id="remover_data_lancamento"
                                v-model="$store.state.item.data_lancamento" disabled>
                        </input-container-component>
                    </div>
                    <div class="form-group">
                        <input-container-component titulo="Descrição" id="removerLancamento">
                            <select name="descricao" class="form-control" id="removerLancamento"
                                v-model="$store.state.item.descricao" disabled>
                                <option v-for="lista in listaDescricao" :key="lista.id" :value="lista.descricao">
                                    {{ lista.descricao }}
                                </option>
                            </select>
                        </input-container-component>
                    </div>
                </div>
                <div>
                    <div class="form-group mt-3">
                        <input-container-component titulo="Valor Comprovante" id="removerValorComprovante">
                            <input type="text" class="form-control" id="removerValorComprovante"
                                placeholder="Informe o Valor Comprovante" v-model="$store.state.item.valor_comprovante"
                                disabled>
                        </input-container-component>
                    </div>
                    <div class="form-group mt-3">
                        <input-container-component titulo="Fornecedor" id="removerFornecedor">
                            <input type="text" class="form-control" id="removerFornecedor"
                                placeholder="Informe o Fornecedor" v-model="$store.state.item.fornecedor" disabled>
                        </input-container-component>
                    </div>
                </div>
                <div>
                    <div class="form-group mt-3">
                        <input-container-component titulo="Tipo Operacao">
                            <select name="removerTipoOperacao" class="form-control" id="removerTipoOperacao"
                                v-model="$store.state.item.tipo_operacao" disabled>
                                <option selected></option>
                                <option value="entrada">Entrada</option>
                                <option value="saida">Saida</option>
                            </select>
                        </input-container-component>
                    </div>
                </div>
                <hr>
                <lanrateio-caixa-component v-if="exibirRateio" ref="lanRateio" :nivelacesso="userJson.nivel_acesso"
                    :capsid="userJson.caps_id"></lanrateio-caixa-component>
            </template>
            <template v-slot:rodape>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                <button type="button" class="btn btn-danger" @click="removerLan($store.state.item.id)"
                    :disabled="$store.state.transacao.status == 'sucesso'"
                    v-if="$store.state.item.aprovacao == 'nao' || userJson.nivel_acesso == 'user'">Remover</button>
            </template>
        </modal-component>

        <modal-component id="modalRateio" titulo="Rateio Lançamento" tipomodal="modal-xl"
            @modal-aberto="$refs.lanRateio.carregarRateiosExistentes()" insert>
            <template v-slot:conteudo>
                <lanrateio-caixa-component ref="lanRateio" :nivelacesso="userJson.nivel_acesso"
                    :capsid="userJson.caps_id"></lanrateio-caixa-component>
            </template>
            <template v-slot:rodape>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
            </template>
        </modal-component>
        <modal-component id="modalExportarTxt" titulo="Exportar TXT" tipomodal="modal-xl">
            <template v-slot:conteudo>
                <div class="row">
                    <div class="col">
                        <input-container-component titulo="Data Inicio" id="data_txt_inicio">
                            <input type="date" class="form-control" id="data_txt_inicio" v-model="dtTxtInicio">
                        </input-container-component>
                    </div>
                    <div class="col">
                        <input-container-component titulo="Data Fim" id="data_txt_fim">
                            <input type="date" class="form-control" id="data_txt_fim" v-model="dtTxtFim">
                        </input-container-component>
                    </div>
                    <div class="col">
                        <input-container-component titulo="Caps">
                            <select name="caps_lan" class="form-control" id="caps_lan" v-model="capsTxt">
                                <option selected></option>
                                <option value="1">Sede</option>
                                <option value="2">Novo Tempo</option>
                                <option value="5">David Capstrano</option>
                                <option value="6">Estação</option>
                                <option value="7">Integração</option>
                                <option value="9">Toninho</option>
                                <option value="10">Esperanca</option>
                            </select>
                        </input-container-component>
                    </div>
                    <div class="col">
                        <input-container-component titulo="">
                            <a :href="'https://contasmoradores.candido.org.br/exportar-txt/' + capsTxt + '/' +
                                dtTxtInicio + '/' + dtTxtFim" class="btn btn-secondary float-end"
                                style="font-size: 11px;">Exportar TXT</a>
                        </input-container-component>
                    </div>
                </div>
            </template>
            <template v-slot:rodape>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
            </template>
        </modal-component>
        <modal-component id="modalExportarXLS" titulo="Exportar XLS" tipomodal="modal-xl">
            <template v-slot:conteudo>
                <div class="row">
                    <div class="col">
                        <input-container-component titulo="Data Inicio" id="data_txt_inicio">
                            <input type="date" class="form-control" id="data_txt_inicio" v-model="dtXlsInicio">
                        </input-container-component>
                    </div>
                    <div class="col">
                        <input-container-component titulo="Data Fim" id="data_txt_fim">
                            <input type="date" class="form-control" id="data_txt_fim" v-model="dtXlsFim">
                        </input-container-component>
                    </div>
                    <div class="col">
                        <input-container-component titulo="">
                            <a :href="'https://contasmoradores.candido.org.br/exportar/cx/' +
                                dtXlsInicio + '/' + dtXlsFim" class="btn btn-secondary float-end"
                                style="font-size: 11px;">Exportar XLS</a>
                        </input-container-component>
                    </div>
                </div>
            </template>
            <template v-slot:rodape>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
            </template>
        </modal-component>
        <div class="modal fade" id="modalInventarioFisico" data-bs-backdrop="static" data-bs-keyboard="false"
            tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="center p-3">
                        <center>
                            <h1>Inventário Fisico</h1>
                        </center>
                        <hr>
                        <center>
                            <h2>Notas</h2>
                        </center>
                        <div class="row mt-2">
                            <div class="col">Valor</div>
                            <div class="col">Quantidade</div>
                        </div>
                        <div class="row">
                            <div class="col">R$ 200,00</div>
                            <div class="col">
                                <input type="number" class="form-control" v-model="item.nota_200"
                                    placeholder="Valor..." />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">R$ 100,00</div>
                            <div class="col">
                                <input type="number" class="form-control" v-model="item.nota_100"
                                    placeholder="Valor..." />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">R$ 50,00</div>
                            <div class="col">
                                <input type="number" class="form-control" v-model="item.nota_50"
                                    placeholder="Valor..." />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">R$ 20,00</div>
                            <div class="col">
                                <input type="number" class="form-control" v-model="item.nota_20"
                                    placeholder="Valor..." />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">R$ 10,00</div>
                            <div class="col">
                                <input type="number" class="form-control" v-model="item.nota_10"
                                    placeholder="Valor..." />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">R$ 5,00</div>
                            <div class="col">
                                <input type="number" class="form-control" v-model="item.nota_5"
                                    placeholder="Valor..." />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">R$ 2,00</div>
                            <div class="col">
                                <input type="number" class="form-control" v-model="item.nota_2"
                                    placeholder="Valor..." />
                            </div>
                        </div>
                        <hr>
                        <center>
                            <h2>Moedas</h2>
                        </center>
                        <div class="row mt-2">
                            <div class="col">R$ 1,00</div>
                            <div class="col">
                                <input type="number" class="form-control" v-model="item.moeda_100"
                                    placeholder="Valor..." />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">R$ 0,50</div>
                            <div class="col">
                                <input type="number" class="form-control" v-model="item.moeda_50"
                                    placeholder="Valor..." />
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col">R$ 0,25</div>
                            <div class="col">
                                <input type="number" class="form-control" v-model="item.moeda_25"
                                    placeholder="Valor..." />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">R$ 0,10</div>
                            <div class="col">
                                <input type="number" class="form-control" v-model="item.moeda_10"
                                    placeholder="Valor..." />
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col">R$ 0,05</div>
                            <div class="col">
                                <input type="number" class="form-control" v-model="item.moeda_5"
                                    placeholder="Valor..." />
                            </div>
                        </div>
                        <hr>
                        <center>
                            <h2>Vales</h2>
                        </center>
                        <div class="row">
                            <div class="col">VALOR</div>
                            <div class="col">
                                <input type="number" class="form-control" v-model="item.vale" placeholder="Valor..." />
                            </div>
                        </div>
                        <hr>
                        <center>
                            <h2>Total</h2>
                        </center>
                        R$ {{ totalInventarioFisico.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}
                    </div>
                    <div class="modal-footer">
                        <div v-if="processando_assinatura" class="overlay">
                            <div class="spinner">Processando...</div>
                        </div>
                        <center>
                            <button type="button" class="btn btn-primary" id="btnSalvarInventario"
                                @click="assinarTermoInventario">Assinar
                                Inventário</button>
                        </center>
                    </div>
                </div>
            </div>
            <div v-if="load_update" class="overlay">
                <div class="spinner">Processando...</div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from 'bootstrap';
export default {
    props: ['user', 'centrocusto'],
    data() {
        return {
            urlBase: 'https://contasmoradores.candido.org.br/api/v1/caixinha',
            urlPaginacao: '',
            urlFiltro: '',
            lancamentos: { data: [] },
            lanDescricao: '',
            lanValorComprovante: '',
            lanFornecedor: '',
            nomePaciente: '',
            codContaCaixa: '',
            centroCusto: '',
            fornecedorId: '',
            operacao: '',
            tipo_operacao: '',
            data_lancamento: '',
            imagem: [],
            urlPreview: "",
            comparaFornecedor: [],
            searchResultsForn: [],
            transacaoStatus: '',
            transacaoDetalhes: {},
            busca: { descricao: '', status: '', caps_id: '', fornecedor: '', id: '' },
            links: {},
            nomeArquivo: "",
            dtTxtInicio: "",
            dtTxtFim: "",
            capsTxt: "",
            verificaSomaRateio: false,
            listaDescricao: {},
            load_update: false,
            exibirRateio: true,
            salvarRateio: 0,
            dtXlsInicio: '',
            dtXlsFim: '',
            processando_assinatura: false,
            item: {
                nota_200: '',
                nota_100: '',
                nota_50: '',
                nota_20: '',
                nota_10: '',
                nota_5: '',
                nota_2: '',
                moeda_100: '',
                moeda_50: '',
                moeda_25: '',
                moeda_10: '',
                moeda_5: '',
                vale: '',
                total: ''
            },
            dataMin: '',
            bloqueioAdicionar: '',
            inventario: []
        }
    },
    methods: {
        resetTransacao() {
            this.transacaoStatus = ''
            this.transacaoDetalhes = ''
            this.lanDescricao = ''
            this.lanValorComprovante = ''
            this.lanFornecedor = ''
            this.nomeArquivo = ""
            this.tipo_operacao = ""
            this.data_lancamento = ""
            this.exibirRateio = false
        },

        removerLan(id) {
            let confirmacao = confirm('Confirmar remoção do registro!')
            if (!confirmacao) return false
            this.load_update = true

            let formData = new FormData()
            formData.append('id', id)

            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post('https://contasmoradores.candido.org.br/api/v1/removelan-cx', formData, config)
                .then(response => {
                    this.carregarLista()
                    this.$store.state.transacao.status = 'sucesso'
                    this.$store.state.transacao.mensagem = response.data
                })
                .catch(errors => {
                    this.$store.state.transacao.status = 'erro'
                    this.$store.state.transacao.mensagem = {
                        mensagem: errors.response.data.mensagem,
                        dados: errors.response.data.errors
                    }
                })
                .finally(() => {
                    this.load_update = false
                })
        },
        habilitarEdicao() {
            let confirmacao = confirm('Após confirmar o status retornara ao estado de criação!')

            if (!confirmacao) return false

            let formData = new FormData()
            formData.append('_method', 'patch')
            formData.append('status', 'criacao')
            formData.append('caps_id', this.$store.state.item.caps_id)


            let config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post('https://contasmoradores.candido.org.br/api/v1/lan_caixinha' + '/' + this.$store.state.item.id, formData, config)
                .then(response => {
                    this.carregarLista()
                    this.$store.state.transacao.status = 'sucesso'
                    this.$store.state.transacao.mensagem = response.data
                })
                .catch(errors => {
                    console.log(errors.response.data)
                })
        },
        carregarListaDescricao() {
            let url = 'https://contasmoradores.candido.org.br/api/v1/descpadrao?apenas_nomes=id,descricao'

            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.get(url, config)
                .then(response => {
                    this.listaDescricao = response.data
                })
                .catch(error => {
                    console.error("Erro na requisição:", error);
                });
        },
        filtroCaps(e) {
            this.busca.caps_id = e.target.value
            this.pesquisar()
        },
        carregarImagem(e) {
            this.imagem = e.target.files;
            this.urlPreview = URL.createObjectURL(this.imagem[0]);
            this.nomeArquivo = this.imagem[0].name
            this.atualizarLanDescricao()
        },
        fetchResultsForn(val) {
            let search;
            if (val === 'adicionar') {
                if (this.lanFornecedor.length < 2) {
                    this.searchResultsForn = [];
                    return;
                }
                search = this.lanFornecedor.toLowerCase();
            } else {
                if (this.$store.state.item.fornecedor.length < 2) {
                    this.searchResultsForn = [];
                    return;
                }
                search = this.$store.state.item.fornecedor.toLowerCase();
            }

            // Busca no estado do Vuex
            const allSuppliers = this.$store.state.fornecedor || [];

            // Filtra os resultados
            this.searchResultsForn = allSuppliers.filter(fornecedor =>
                fornecedor.razao_social.toLowerCase().includes(search)
            );

            this.comparaFornecedor = this.searchResultsForn;
        },
        async setFornecedorStore() {
            try {
                const response = await axios.get(`/busca-fornecedor-store?caps_id=${this.userJson.caps_id}`);
                this.$store.state.fornecedor = response.data;
            } catch (error) {
                console.error("Erro ao buscar registros:", error);
            }
        },
        setFornecedor(item, val) {
            if (val == 'adicionar') {
                this.lanFornecedor = item.razao_social
                this.fornecedorId = item.id
            } else {
                this.$store.state.item.fornecedor = item.razao_social
                this.$store.state.item.forn_id = item.id
            }
            this.searchResultsForn = [];
        },
        async carregaInventario() {
            let ano_inv = new Date().getFullYear()
            let mes_inv = new Date().getMonth() + 1
            let url = 'https://contasmoradores.candido.org.br/inventario/' + this.userJson.caps_id + '/' + ano_inv + '/' + mes_inv

            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }
            axios.get(url, config)
                .then(response => {
                    this.inventario = response.data.inventario
                })
                .catch(errors => {
                })
        },
        async fetchResultsStoreCx() {
            await this.carregaInventario()
            try {
                const response = await axios.get(`/busca-pacientes-store-cx?caps_id=${this.userJson.caps_id}`);

                const mapaSaldos = Object.fromEntries(
                    this.inventario.map(item => [item.nome_paciente, item.saldo])
                )

                this.$store.state.pacientes_cx = response.data.map(item => ({
                    ...item,
                    saldo: mapaSaldos[item.nome] || "0,00"
                }))
            } catch (error) {
                console.error("Erro ao buscar registros:", error);
            }
        },
        aprovacao() {
            if (this.$store.state.item.data_lancamento <= this.dataMin && this.userJson.periodo_contabil == "fechado") {
                alert(`Fora do período de aprovação`)
                return
            }

            let confirmacao = confirm('Confirmar aprovação?')
            if (!confirmacao) return false
            this.load_update = true
            let formData = new FormData()
            formData.append('id', this.$store.state.item.id)
            formData.append('caps_id', this.userJson.caps_id)
            let config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post('https://contasmoradores.candido.org.br/api/v1/aprovacao-cx', formData, config)
                .then(response => {
                    this.carregarLista()
                    this.$store.state.transacao.status = 'sucesso'
                    this.$store.state.transacao.mensagem = response.data
                })
                .catch(errors => {
                    console.log(errors.response)
                    this.$store.state.transacao.status = 'erro'
                    this.$store.state.transacao.mensagem = {
                        mensagem: errors.response.data.message,
                        dados: errors.response.data.errors
                    }
                })
                .finally(() => {
                    this.load_update = false
                })
        },
        reprovar() {
            let confirmacao = confirm('Desfazer aprovação?')
            if (!confirmacao) return false
            this.load_update = true
            let formData = new FormData()
            formData.append('id', this.$store.state.item.id)
            formData.append('caps_id', this.userJson.caps_id)
            let config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post('https://contasmoradores.candido.org.br/api/v1/reprovacao-cx', formData, config)
                .then(response => {
                    this.carregarLista()
                    this.$store.state.transacao.status = 'sucesso'
                    this.$store.state.transacao.mensagem = response.data
                })
                .catch(errors => {
                    console.log(errors.response)
                    this.$store.state.transacao.status = 'erro'
                    this.$store.state.transacao.mensagem = {
                        mensagem: errors.response.data.message,
                        dados: errors.response.data.errors
                    }
                })
                .finally(() => {
                    this.load_update = false
                })
        },
        atualizarLanDescricao() {
            let formData = new FormData()
            formData.append('_method', 'patch')
            formData.append('centro_custo', this.$store.state.item.caps.centro_custo)
            formData.append('descricao', this.$store.state.item.descricao)
            formData.append('fornecedor', this.$store.state.item.fornecedor)
            formData.append('valor_comprovante', this.$store.state.item.valor_comprovante)
            formData.append('status', this.$store.state.item.status)
            formData.append('tipo_operacao', this.$store.state.item.tipo_operacao)
            formData.append('data_lancamento', this.$store.state.item.data_lancamento.split(' ')[0])
            formData.append('caps_id', this.$store.state.item.caps_id)
            formData.append('forn_id', this.$store.state.item.forn_id)
            if (this.imagem[0]) {
                formData.append("imagem", this.imagem[0]);
            }

            let config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post('https://contasmoradores.candido.org.br/api/v1/lan_caixinha' + '/' + this.$store.state.item.id, formData, config)
                .then(response => {
                    this.salvarRateio++
                    this.carregarLista()
                    this.$store.state.transacao.status = 'sucesso'
                    this.$store.state.transacao.mensagem = response.data
                    this.exibirRateio = true
                })
                .catch(errors => {
                    console.log(errors.response)
                    this.$store.state.transacao.status = 'erro'
                    this.$store.state.transacao.mensagem = {
                        mensagem: errors.response.data.message,
                        dados: errors.response.data.errors
                    }
                })
        },
        pesquisar() {
            let filtro = ''
            for (let chave in this.busca) {
                if (this.busca[chave]) {
                    if (filtro != '') {
                        filtro += ';'
                    }
                    if (chave == 'caps_id') {
                        filtro += chave + ':like:' + this.busca[chave]
                    } else {
                        filtro += chave + ':like:' + this.busca[chave] + '%'
                    }
                }
            }
            if (filtro != '') {
                if (this.userJson.nivel_acesso == 'adm') {
                    this.urlPaginacao = 'page=1'
                    if (this.userJson.nivel_acesso != 'adm') {
                        this.urlFiltro = ';' + filtro
                    } else {
                        this.urlFiltro = '&filtro=' + filtro
                    }

                } else {
                    this.urlPaginacao = 'page=1'
                    this.urlFiltro = ';' + filtro
                }
            } else {
                this.urlFiltro = ''
            }
            this.carregarLista()
        },
        paginacao(l) {
            if (l.url) {
                this.urlPaginacao = l.url.split('?')[1]
                this.carregarLista()
            }
        },
        carregarLista() {
            let url = ''
            if (this.userJson.nivel_acesso != 'adm') {
                url = 'https://contasmoradores.candido.org.br/api/v1/lan_caixinha' + '?' + this.urlPaginacao + '&filtro=caps_id:=:' + this.userJson.caps_id + this.urlFiltro
            } else {
                url = 'https://contasmoradores.candido.org.br/api/v1/lan_caixinha' + '?' + this.urlPaginacao + this.urlFiltro
            }
            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }
            axios.get(url, config)
                .then(response => {
                    this.lancamentos = response.data
                    this.verificaStatus()
                    if (this.$store.state.item.id) {
                        const updateItem = this.lancamentos.data.find(dado => dado.id === this.$store.state.item.id)
                        this.$store.commit('SET_ITEM', updateItem)
                    }
                    this.fetchResultsStoreCx()
                })
                .catch(errors => {
                })
        },
        async verificaStatus() {
            let url = 'https://contasmoradores.candido.org.br/verifica-status/' + this.userJson.caps_id

            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }
            await axios.get(url, config)
                .then(response => {
                    this.bloqueioAdicionar = response.data.pendente
                })
                .catch(errors => {
                })
        },
        carregarBotaoAdicionar() {
            if (this.bloqueioAdicionar == 'sim') {
                alert(`Ha lançamentos em modo criação pendentes!\n
                Finalize para adicionar um novo.`)
            }
            if (this.bloqueioAdicionar == 'nao') {
                $("#modalLanDescricao").modal("show");
            }
        },
        salvarLanDescricao() {
            let formData = new FormData()
            formData.append('centro_custo', this.centrocusto)
            formData.append('descricao', this.lanDescricao)
            formData.append('valor_comprovante', this.lanValorComprovante)
            formData.append('fornecedor', this.lanFornecedor)
            formData.append('status', 'criacao')
            formData.append('tipo_operacao', this.tipo_operacao)
            formData.append('data_lancamento', this.data_lancamento.split(' ')[0])
            formData.append('caps_id', this.userJson.caps_id)
            formData.append('forn_id', this.fornecedorId)

            let config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post('https://contasmoradores.candido.org.br/api/v1/lan_caixinha', formData, config)
                .then(response => {
                    this.carregarLista()
                    this.transacaoStatus = 'sucesso'
                    this.transacaoDetalhes = {
                        mensagem: 'Registro salvo com sucesso!'
                    }
                    this.exibirRateio = true
                    setTimeout(() => {
                        const btn = document.getElementById(`lan_rateio${response.data.id}`)
                        if (btn) btn.click()
                    }, 1000)
                })
                .catch(errors => {
                    console.log(errors.response.data)
                    this.transacaoStatus = 'erro'
                    this.transacaoDetalhes = {
                        mensagem: errors.response.data.mensagem,
                        dados: errors.response.data.errors
                    }
                })
        },
        aplicarMascaraLanDesc(event, val) {
            let valor = event.target.value;

            // Remove todos os caracteres que não são números
            valor = valor.replace(/\D/g, '');

            // Se estiver vazio, evita erro e mantém a string vazia
            if (valor === '') {
                if (val === 'adicionar') this.lanValorComprovante = '';
                if (val === 'atualizar') this.$store.state.item.valor_comprovante = '';
                return;
            }

            // Converte para número e divide por 100 para formatar como decimal
            valor = (parseInt(valor, 10) / 100).toFixed(2);

            // Formata o valor no padrão brasileiro (vírgula decimal, pontos para milhar)
            valor = valor.replace('.', ',');
            valor = valor.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

            // Atualiza o valor no item do array
            if (val === 'adicionar') this.lanValorComprovante = valor;
            if (val === 'atualizar') this.$store.state.item.valor_comprovante = valor;

            // Atualiza a interface do input
            this.$nextTick(() => {
                event.target.value = valor;
            });
        },
        carregarInventarioFisico() {
            let url = ''
            if (this.userJson.nivel_acesso != 'adm') {
                url = 'https://contasmoradores.candido.org.br/api/v1/inventario-fisico'
            }
            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }
            axios.get(url, config)
                .then(response => {
                    if (response.data.pendente == 'nao') {
                        $("#modalInventarioFisico").modal("show");
                    }

                })
                .catch(errors => {
                })
        },
        verificaAssinaturaInventario() {
            if (this.userJson.nivel_acesso != 'adm') {
                url = 'https://contasmoradores.candido.org.br/api/v1/inventario-fisico'
                axios.get(url, config)
                    .then(response => {
                        if (response.data.pendente == 'nao') {
                            $("#modalInventarioFisico").modal("show");
                        }
                    })
                    .catch(errors => {
                    })
            }
        },
        assinarTermoInventario() {

            this.processando_assinatura = true;
            const botao = document.getElementById('btnSalvarInventario');
            botao.disabled = true;
            botao.innerHTML = 'Salvando...';

            this.item.total = this.totalInventarioFisico;
            let formData = new FormData()
            formData.append('nota_2', this.item.nota_2)
            formData.append('nota_5', this.item.nota_5)
            formData.append('nota_10', this.item.nota_10)
            formData.append('nota_20', this.item.nota_20)
            formData.append('nota_50', this.item.nota_50)
            formData.append('nota_100', this.item.nota_100)
            formData.append('nota_200', this.item.nota_200)
            formData.append('moeda_005', this.item.moeda_5)
            formData.append('moeda_010', this.item.moeda_10)
            formData.append('moeda_025', this.item.moeda_25)
            formData.append('moeda_050', this.item.moeda_50)
            formData.append('moeda_100', this.item.moeda_100)
            formData.append('vale', this.item.vale)
            formData.append('total_geral', this.item.total)
            formData.append('caps_id', this.userJson.caps_id)

            let config = {
                headers: {
                    Accept: "application/json",
                    Authorization: this.token,
                },
            };

            axios
                .post('https://contasmoradores.candido.org.br/api/v1/inventario-fisico', formData, config)
                .then((response) => {
                    alert('Inventario Fisico assinado com sucesso!');

                    const modalElement = document.getElementById('modalInventarioFisico');

                    // Cria ou recupera a instância usando a classe importada
                    const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
                    modalInstance.hide();
                })
                .catch((error) => {

                    let msgError = ''
                    const erros = error.response.data.errors

                    Object.entries(erros).forEach(([campo, mensagens]) => {
                        mensagens.forEach(mensagem => {
                            msgError += `${campo}: ${mensagem}\n`;
                        });
                    });

                    alert(msgError)

                    if (error.response) {
                        console.error("Erro do servidor:", error.response.data);
                    } else {
                        console.error("Erro na execução do script:", error.message);
                    }
                })
                .finally(() => {
                    this.processando_assinatura = false;
                    botao.disabled = false;
                    botao.innerHTML = 'Entendido';
                });
        },
        aplicarMascaraLanRat(event, item, campo) {

            let valor = event.target.value.replace(/\D/g, '');

            if (!valor) {
                item[campo] = '';
                return;
            }

            item[campo] = (valor / 100)
                .toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });

        },
        ajustarRangeData() {
            if (this.userJson.nivel_acesso == 'adm' || this.userJson.periodo_lancamento == "aberto") return

            const hoje = new Date()

            let dataMin

            if (hoje.getDate() <= 15) {

                // primeiro dia do mês anterior
                dataMin = new Date(
                    hoje.getFullYear(),
                    hoje.getMonth() - 1,
                    1
                )

            } else {

                // primeiro dia do mês atual
                dataMin = new Date(
                    hoje.getFullYear(),
                    hoje.getMonth(),
                    1
                )

            }

            this.dataMin = dataMin.toISOString().split('T')[0]
        },
        bloquearTeclado(event) {
            event.target.blur(); // Impede a abertura do teclado em mobile
        }
    },
    mounted() {
        this.carregarInventarioFisico()
        this.carregarLista()
        this.ajustarRangeData()
        this.setFornecedorStore()
        this.carregarListaDescricao()
        // Obtém o elemento da modal pelo ID
        const modalElement = document.getElementById('modalLanDescricao');
        const modalElementAtualizar = document.getElementById('modalLancamentoAtualizar');

        // Adiciona o evento de fechamento da modal para resetar as variáveis
        modalElement.addEventListener('hidden.bs.modal', () => {
            setTimeout(() => {
                this.exibirRateio = true
            }, 1000)
        });
        modalElementAtualizar.addEventListener('hidden.bs.modal', () => {
            this.resetTransacao()
            this.carregarLista()
        });
        modalElementAtualizar.addEventListener('show.bs.modal', () => {
            this.exibirRateio = true;
        });
    },
    beforeUnmount() {
        // Remove o evento ao desmontar o componente para evitar vazamento de memória
        const modalElement = document.getElementById('modalLanDescricao');
        const modalElementAtualizar = document.getElementById('modalLancamentoAtualizar');
        modalElement.removeEventListener('hidden.bs.modal', this.resetTransacao);
        modalElementAtualizar.addEventListener('hidden.bs.modal', this.resetTransacao);
    },
    computed: {
        token() {
            let token = 'Bearer ' + document.cookie.split(';').find(indice => {
                return indice.includes('token=')
            }).split('=')[1]
            return token
        },

        userJson() {
            return JSON.parse(this.user);
        },
        formattedValue: {
            get() {
                return this.lanValorComprovante;
            },
            set(value) {
                // Converte para um formato adequado sem perder os centavos
                this.lanValorComprovante = value.replace(/[^0-9,]/g, '').replace(/^0+/, '') || "0,00";
            }
        },
        verificaImagemStatus() {
            if (this.$store.state.item.status == 'criacao' && this.$store.state.item.imagem) {
                return true
            } else {
                return false
            }
        },
        totalInventarioFisico() {
            const valores = {
                nota_200: 200,
                nota_100: 100,
                nota_50: 50,
                nota_20: 20,
                nota_10: 10,
                nota_5: 5,
                nota_2: 2,
                moeda_100: 1,
                moeda_50: 0.50,
                moeda_25: 0.25,
                moeda_10: 0.10,
                moeda_5: 0.05,
            };

            let total = 0;

            for (const campo in valores) {

                const quantidade = parseInt(this.item[campo]) || 0;

                total += quantidade * valores[campo];

            }

            total += parseFloat(this.item.vale) || 0;

            return total.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        }
    }
}
</script>
<style scoped>
.list-group-item {
    cursor: pointer;
}

.text-success {
    color: green;
    font-weight: bold;
}

.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(270deg, #ff6b6b, #feca57, #48dbfb, #1dd1a1);
    background-size: 800% 800%;
    animation: gradientAnimation 10s ease infinite;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    opacity: 0.6;
}

.spinner {
    color: #000;
    font-size: 1.5rem;
    font-weight: bold;
    text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

@keyframes gradientAnimation {
    0% {
        background-position: 0% 50%;
    }

    50% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 0% 50%;
    }
}
</style>